<template>
	<v-autocomplete
		v-model="purpose"
		:items="purposes"
		:loading="purposeLoading"
		item-title="name"
		item-value="id"
		hide-details
		clearable
		v-bind="$attrs"
		@update:model-value="$emit('input', $event)"
	>
		<template
			v-for="(_, slot) of $slots"
			#[slot]="scope"
		>
			<slot
				:name="slot"
				v-bind="scope"
			/>
		</template>
	</v-autocomplete>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';
import {
	displayError,
} from 'laravel-front-library';

export default {
	name: 'PurposeSelect',
	props: {
		value: {
			type: Number,
			default: null
		}
	},

	emits: ['input',],

	data () {
		return {
			purpose: this.value,
			purposes: [],
			purposeLoading: false,
		};
	},

	mounted () {
		this.loadPurposes();
	},

	methods: {
		/**
		 * Get possible purposes for email template types
		 */
		loadPurposes () {
			this.purposeLoading = true;
			axios.get('/bo/emailtemplatetypes/purposes').then(({
				data
			}) => {
				this.purposes = data.items;
			}).catch(() => {
				displayError(this.$gettext('Couldn\'t load purposes!'));
			}).finally(() => {
				this.purposeLoading = false;
			});
		},
	}
};
</script>
